    <app-table-header-column name="date" size="small">
      <span content>
        Entrada
        <app-filter-button
          [column]="'receivedAt'"
          [menu]="receivedAtFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #receivedAtFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #receivedAtFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por data de entrada</h4>
        <button (click)="sort('receivedAt', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['receivedAt'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('receivedAt', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['receivedAt'] && sortDirection == 'asc'"></i>
        </button>
        <form [formGroup]="dateFiltersForm">
          <mat-form-field appearance="outline">
            <mat-label>Data inicial</mat-label>
            <input matInput [matDatepicker]="startDatePicker" formControlName="start" [max]="maxDate" disabled
              (dateChange)="onReceivedAtStartDateChange()" required>
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Data final</mat-label>
            <input matInput [matDatepicker]="endDatePicker" formControlName="end" [max]="maxDate"
              [min]="minDate" disabled (dateChange)="onReceivedAtEndDateChange()" required
            >
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <section class="actions">
            <button mat-stroked-button class="gray-1" (click)="clearFilters(receivedAtFilterBtn.menuTrigger, 'receivedAt')">
              Limpar
            </button>
            <button mat-raised-button class="primary-1" (click)="applyFilters(receivedAtFilterBtn.menuTrigger)"
              [disabled]="isReceivedAtSaveBtnDisabled">
              Salvar
            </button>
          </section>
        </form>
      </div>
    </mat-menu>

    <app-table-header-column name="date" size="small">
      <span content>
        Últ movimentação
        <app-filter-button
          [column]="'lastMovedAt'"
          [menu]="lastMovedAtFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #lastMovedAtFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #lastMovedAtFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Ordenar por última movimentação</h4>
        <button (click)="sort('lastMovedAt', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['lastMovedAt'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('lastMovedAt', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['lastMovedAt'] && sortDirection == 'asc'"></i>
        </button>
        <form [formGroup]="lastMovedAtForm">
          <mat-form-field appearance="outline">
            <mat-label>Data inicial</mat-label>
            <input matInput [matDatepicker]="LastMovedAtStartDatePicker" formControlName="start" [max]="lastMovedAtMaxDate" disabled
              (dateChange)="onLastMovedAtStartDateChange()" required>
            <mat-datepicker-toggle matSuffix [for]="LastMovedAtStartDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #LastMovedAtStartDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Data final</mat-label>
            <input matInput [matDatepicker]="lastMovedAtEndDatePicker" formControlName="end" [max]="lastMovedAtMaxDate" disabled
              (dateChange)="onLastMovedAtEndDateChange()" [min]="lastMovedAtMinDate" required
            >
            <mat-datepicker-toggle matSuffix [for]="lastMovedAtEndDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #lastMovedAtEndDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <section class="actions">
            <button mat-stroked-button class="gray-1" (click)="clearFilters(receivedAtFilterBtn.menuTrigger, 'lastMovedAt')">
              Limpar
            </button>
            <button mat-raised-button class="primary-1" (click)="applyFilters(receivedAtFilterBtn.menuTrigger)"
              [disabled]="isLastMovedAtSaveBtnDisabled">
              Salvar
            </button>
          </section>
        </form>
      </div>
    </mat-menu>

    <app-table-header-column name="section" size="small">
      <span content>
        Setor
        <app-filter-button
          [column]="'section'"
          [menu]="sectionFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #sectionFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #sectionFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por setor</h4>
        <button (click)="sort('section', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['section'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('section', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['section'] && sortDirection == 'asc'"></i>
        </button>
          <app-autocomplete-input
            [label]="'Setor'"
            [control]="sectionFormControl">
          </app-autocomplete-input>
          <section class="actions">
            <button mat-stroked-button class="gray-1" (click)="clearFilters(sectionFilterBtn.menuTrigger, 'section')">
              Limpar
            </button>
            <button mat-raised-button class="primary-1" (click)="applyFilters(sectionFilterBtn.menuTrigger)">Salvar</button>
          </section>
      </div>
    </mat-menu>

    <app-table-header-column name="alias" size="smaller">
      <span content>
        Posição
        <app-filter-button
          [column]="'alias'"
          [menu]="aliasFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #aliasFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #aliasFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por posição</h4>
        <button (click)="sort('alias', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['alias'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('alias', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['alias'] && sortDirection == 'asc'"></i>
        </button>
        <app-autocomplete-input
          [label]="'Posição'"
          [control]="aliasFormControl">
        </app-autocomplete-input>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(aliasFilterBtn.menuTrigger, 'alias')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(aliasFilterBtn.menuTrigger)">Salvar</button>
        </section>
      </div>
    </mat-menu>

    <app-table-header-column name="levelName" size="smallest">
      <span content>
        Altura
        <app-filter-button
          [column]="'z'"
          [menu]="levelNameFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #levelFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #levelNameFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por altura</h4>
        <button (click)="sort('z', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['z'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('z', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['z'] && sortDirection == 'asc'"></i>
        </button>
        <app-autocomplete-input
          [label]="'Nível'"
          [control]="levelNameFormControl">
        </app-autocomplete-input>
          <section class="actions">
            <button mat-stroked-button class="gray-1" (click)="clearFilters(levelFilterBtn.menuTrigger, 'z')">
              Limpar
            </button>
            <button mat-raised-button class="primary-1" (click)="applyFilters(levelFilterBtn.menuTrigger)">Salvar</button>
          </section>
      </div>
    </mat-menu>

    <app-table-header-column name="product-code" size="small">
      <span content>
        Código do Item
        <app-filter-button
          [column]="'sku'"
          [menu]="productSkuFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #skuFilterBtn>
        </app-filter-button>
      </span>

    </app-table-header-column>

    <mat-menu #productSkuFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por código do item</h4>
        <button (click)="sort('sku', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['sku'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('sku', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['sku'] && sortDirection == 'asc'"></i>
        </button>
        <app-autocomplete-input
          [label]="'Sku'"
          [placeholder]="'Código do item'"
          [control]="productSkuFormControl">
        </app-autocomplete-input>
          <section class="actions">
            <button mat-stroked-button class="gray-1" (click)="clearFilters(skuFilterBtn.menuTrigger, 'sku')">
              Limpar
            </button>
            <button mat-raised-button class="primary-1" (click)="applyFilters(skuFilterBtn.menuTrigger)">Salvar</button>
          </section>
      </div>
    </mat-menu>

    <app-table-header-column name="description" size="medium">
    <span content>
      Descrição
      <app-filter-button
        [column]="'productName'"
        [menu]="descriptionFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #descriptionFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #descriptionFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por descrição</h4>
      <button (click)="sort('productName', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('productName', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Descrição" [formControl]="productNameFormControl" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(descriptionFilterBtn.menuTrigger, 'productName')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(descriptionFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="family" size="medium">
    <span content>
      Família
      <app-filter-button
        [column]="'productDescription'"
        [menu]="familyFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #familyFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #familyFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por família</h4>
      <button (click)="sort('productDescription', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productDescription'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('productDescription', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productDescription'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Família" [formControl]="productDescriptionFormControl" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(familyFilterBtn.menuTrigger, 'productDescription')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(familyFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

    <app-table-header-column name="quantity" size="smallest">
      <span content>
        Qtd
        <app-filter-button
          [column]="'quantity'"
          [menu]="quantityFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #quantityFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #quantityFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por quantidade</h4>
        <button (click)="sort('quantity', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['quantity'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('quantity', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['quantity'] && sortDirection == 'asc'"></i>
        </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Quantidade" type="number" [formControl]="quantityFormControl" min="1" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1"
            (click)="clearFilters(quantityFilterBtn.menuTrigger, 'quantity')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(quantityFilterBtn.menuTrigger)">Salvar</button>
        </section>
      </div>
    </mat-menu>

    <app-table-header-column name="state" size="small">
      <span content>
        Estado
        <app-filter-button
          [column]="'state'"
          [menu]="stateFilterMenu"
          [appliedFilters]="appliedFilters"
          [sortColumn]="sortColumn"
          #stateFilterBtn>
        </app-filter-button>
      </span>
    </app-table-header-column>

    <mat-menu #stateFilterMenu="matMenu">
      <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <h4>Filtrar por estado</h4>
        <button (click)="sort('state', 'desc')" mat-menu-item>
          Ordem decrescente
          <i class="uil uil-check" *ngIf="showCheckIcon['state'] && sortDirection == 'desc'"></i>
        </button>
        <button (click)="sort('state', 'asc')" mat-menu-item>
          Ordem crescente
          <i class="uil uil-check" *ngIf="showCheckIcon['state'] && sortDirection == 'asc'"></i>
        </button>
        <mat-form-field class="dropdown" appearance="outline">
          <mat-label>Estado</mat-label>
          <mat-select [(value)]="stateValue">
            <mat-option *ngFor="let option of stateOptions" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(stateFilterBtn.menuTrigger, 'state')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(stateFilterBtn.menuTrigger)">Salvar</button>
        </section>
      </div>
    </mat-menu>

    <app-table-header-column name="messages" size="smallest">
      <span content>Comentários</span>
    </app-table-header-column>
